import React, { useEffect } from "react";
import { Upload, Tabs, Drawer,Spin, message } from 'antd';
import styles from "./index.module.less";
import request, { METHODS } from "@/api";
import ImageUpload, { AcceptType } from "@/components/Upload/ImageUpload.tsx";
import { SubmitOfflineElec } from '@/services/goods';
import { fileLink } from "@/utils/download";

const SubmitSignContract = ({ state = {}, setState = () => ({}), currentFileList = [], quoteId = '', title = '', reload = () => ({}) }: any) => 
  {

    useEffect(() => {
      setState({signDataNew: []})
    }, [state.signVisible]);

    const onSaveSign = async () => {
      if (!state.signDataNew || !state.signDataNew?.length) {
        message.info({
          content: '请上传附件图片',
          style: {zIndex: 10000}
        })
        return false;
      }
      try {
        setState({submitLoading: true})
        const res = await SubmitOfflineElec({
          quoteId,
          quoteContractId: state.quoteContractId,
          elecId: state.elecContractId,
          attachList: state.signDataNew
        })
        message.info(res?.message || '提交成功')
        reload();
        setState({submitLoading: false}) 
        setState({signSignVisible: false })
      } catch (err) {
        message.info('提交失败')
        setState({submitLoading: false}) 
      }
    }

    const beforeUpload = (file: any) => {
      const type = file.name.split('.').slice(-1).join().toLowerCase();
      const isJpgOrPng = AcceptType.picture.includes(type);
      const isLt20M = file.size / 1024 / 1024 < 20;
  
      if (!isJpgOrPng) {
        message.info(`请上传${AcceptType.picture}格式`);
        return Upload.LIST_IGNORE;
      }
      if (!isLt20M) {
        message.info('图片大小不能大于20MB');
        return Upload.LIST_IGNORE;
      }
    }
  
    const onChangeImg = (file: any) => {
      const newFile = file.map((item: any) => {
        const {originalFilename, filePath} = item.response.data;
        return {
          attachType: 'pic',
          busStage: 'sign',
          attachPath: filePath,
          attachName: originalFilename,
        }
      })
      setState({signDataNew: newFile})
    }
  
    /*const onRemoveImg = (file: any) => {
      const id = file.id || file.response.data.id
      const newFiles = state.signDataNew.filter((item: any) => (item.id && item.id !== id) || (item.addKey && item.addKey !== id))
      setState({signDataNew: newFiles});
      if (file.id) request(`/bd-web/elecAttachments/${file.id}`, {method: METHODS.DELETE}).then(res => {
        Toast.show(res.message);
        getSignData()
      })
    }*/

    return (
        <Drawer
          title={title || '提交签约'}
          zIndex={4000}
          width={'62%'}
          open={state.signSignVisible}
          onClose={() => setState({signSignVisible: false })}
          maskClosable={false}
        >
          <div className={styles.modalFull}>
            <Spin spinning={state.submitLoading}>
              <div className={styles.modalFullWin}>
                <ImageUpload
                  limit={20} 
                  acceptType={AcceptType.picture}
                  readonly={state.signReadOnly}
                  fileList={currentFileList}
                  beforeUpload={beforeUpload}
                  onChange={(file: any) => {onChangeImg(file)}}
                />
                <div className={styles.footer}>
                  <div className={styles.buttonBox}>
                    {
                      !state.signReadOnly && (
                        <div
                          className={styles.addButton}
                          onClick={() => onSaveSign()}
                        >
                          <span>保存</span>
                        </div>
                      )
                    }
                  </div>
                </div>
              </div>
            </Spin>
          </div>
        </Drawer>
    );
  };

export default SubmitSignContract;
